





















































































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import CouponMixin from './mixin/mixin.vue';

@Component
export default class Coupon extends mixins(CouponMixin) {
}
